const ja = {
	storeManagement: '店舗管理',
	storeType: '店舗タイプ',
	applicationStatus: '審査状況',
	storeStatus: '店舗状況',
	storeCode: '店舗番号',
	storeName: '店名',
	storeAddress: '店舗住所',
	group: 'グループ',
	omniGroup: '所属グループ',
	groupTip: 'グループについて',
	addGroup: 'グループ作成',
	groupTipText: 'グループ管理を使用すると、会社の地域、ビジネスなどの権限を分離したり、複数の Web サイトやストアなどからのデータを結合および分析したりできます。そうでない場合は、デフォルトのグループ管理が使用されます。',
	applicationTime: '申請日時',
	withdrawAccount: '出金口座番号',
	all: '全て',
	directStore: '直営店',
	franchiseStore: 'フランチャイズ店',
	approved: '審査通過',
	decline: '拒否されました',
	pending: '審査中',
	modify: '審査に通らなかった場合',
	noStoreAdded: 'まだストアを追加していません',
	realNameAuthFirst: '最初に実名認証を送信してください',
	submitRealNameAuthFirst: '最初に実名認証を送信してからストアを追加する必要があります',
	submitAuthMaterials: '実名資料の提出',
	submitStoreInfo: '提出',
	storeDetails: '店舗詳細',
	addStore: '新規店舗追加',
	fillLegalPerson: '法人情報をご入力ください',
	fillBeneficiary: '受取人情報をご記入ください',
	fillDirector: 'ディレクター情報を入力してください',
	basicInfo: '基本情報',
	storeInfo: '店舗情報',
	directStoreType: '直営店',
	franchiseStoreType: 'フランチャイズ店',
	storeNameEn: '店舗名（英語入力のみ対応）',
	storePhone: '店舗電話番号',
	areaCodeRequired: '国番号を選択してください',
	storePhoneRequired: '店舗電話番号を入力してください',
	storePhoneLegacyTip: '過去の電話番号から国番号を識別できないため、国番号と電話番号を再入力してください。',
	businessLicenseNo: '営業許可証番号',
	licenseEffectiveDate: '有効期間（開始）',
	licenseExpiryDate: '有効期限',
	businessRegistrationCertificate: '会社設立証明書',
	hkBusinessLicenseNo: '事業者登録番号（上8桁）',
	// HK 修改
	hkBusinessRegistrationCertificate: '事業者登録証明書',
	// HK 新增
	hkLicenseEffectiveDate: 'ビジネス登録証明書の発効日',
	// HK 修改
	hkLicenseExpiryDate: '事業者登録証明書の有効期限',
	// HK 修改
	hkRegistrationCertificate: '会社設立証明書',
	// HK 新增
	hkRegistrationCertificateNo: '登録証番号',
	// HK 新增
	hkCompanyEstablishedDate: '会社登録時期',
	// HK 新增
	hkAnnualReport: '設立フォームまたは年次申告書',
	// HK 新增,
	hkAnnualReportTips: 'NNC1（法人設立届）は設立後1年以内に提出可能ですが、NAR1（年次申告書）は設立から1年以上経過した場合に提出する必要があります。',
	// HK 新增
	hkAddressProof: '住所証明',
	// 9231 HK新增
	hkBillOrcontract: 'オフィスの賃貸借契約書',
	// 9231 HK新增
	hkBankAccountInformation: '同名義の銀行口座証明書または預金口座情報',
	// 9231 HK新增
	hkBankAccountInformationTips: '有効期限が 3 か月以内の銀行証明書をご提示ください',
	// 9231 HK新增
	companyRegisterCountry: '登記国 / 地域',
	hkCompanyEnName: '会社名（英語）',
	licenseImage: '営業許可証画像',
	articlesOfAssociation: '定款（ストア）',
	country: '国 / 地域',
	province: '都道府県 / 州',
	city: '市区町村',
	district: '区 / 地域',
	addressEn: '詳細住所（英語）',
	postcode: '郵便番号',
	relatedPersonnel: '関連担当者情報',
	fillStoreLegalPerson: '法定代表者情報を入力してください',
	addLegalPerson: '法定代表者を追加',
	fillStoreDirectorPerson: '会社の役員情報を入力してください',
	addDirectorPerson: '役員を追加',
	fillStoreBeneficiary: '実質的支配者情報を入力してください',
	addBeneficiary: '実質的支配者を追加',
	otherMaterials: 'その他の資料',
	storePhotos: '店舗外観画像',
	showStoreNumber: '※店舗番号または看板が確認できること',
	priceList: '価格表',
	consumptionPriceList: '店内料金表',
	warehousePhotos: '倉庫の写真',
	purchaseRecords: '仕入・購買履歴',
	settlementAccount: '決済口座',
	settlementAccountType: '決済口座の種類',
	distributionAccount: '送金口座',
	withdrawAccountNumber: '出金口座番号',
	storeLegalPerson: '店舗法人',
	storeBeneficiary: '店舗受益者',
	directorPerson: '店長',
	confirm: '確認する',
	cancel: 'キャンセル',
	search: '検索',
	reset: 'リセット',
	addStoreBtn: '店舗追加',
	operation: '操作',
	viewDetails: '詳細',
	saveSuccess: '正常に保存されました',
	required: '必須項目です',
	enNameRule: '英文字を入力してください',
	emailRule: 'メールの形式が正しくありません',
	account: {
		crzStoreType: '店舗タイプ',
		crzCategory: 'ストアの主要カテゴリ',
		crzUsage: '事業目的',
		crzEmail: 'ストアのメールアドレス',
		partnershipDeedImage: 'パートナー証明書',
		shareStructureImage: '株式構成',
		legal: '法人',
		legal1: '店舗運営者',
		storeBeneficiary: '店舗受益者 (資本 ≥ 25%)',
		storePartner: 'ストアパートナー',
		storeAgent: 'エージェント (オプション)',
		addPartner: 'パートナーを追加',
		addAgent: 'エージェントの追加',
		fillAgentPerson: 'エージェント情報を入力してください',
		fillPartner: 'パートナー情報を入力してください',
		success: '送信成功',
		applyCrz: '配信口座申請',
		pending: '審査中',
		notActive: '(アクティブ化されていません)',
		active: 'アカウントをアクティブ化する',
		needLiveness: '検討中、顔認証が必要',
		liveness: '顔認識',
		sole: '個人事業主',
		partner: 'パートナーシップ',
		company: '株式会社',
		tip: '審査要件に従い、リンクより以下の方々の顔認証を完了してください。',
		reload: 'ステータスを更新する',
		copy: 'コピー',
		copied: 'クリップボードにコピーされました',
		copyfailed: 'コピーに失敗しました。後でもう一度お試しください',
		incomplete: '未完了',
		failed: '失敗',
		completed: '完了',
		submit: '申請書を提出する',
		policy1: '読んで同意しました',
		policy2: 'お客様のデータは処理され、機密として厳重に保管されます。'
	},
	phTaxCardNumber: '法人税番号',
	// PH新增
	phTaxCardImg: '法人税カード証明書（イメージ）',
	// PH新增
	companyRegisterCertificate: '会社設立証明書',
	// 公司注册证明
	generalInfoTable: '一般情報シート',
	// 公司基本信息表
	specialIndustryLicense: '特別業種許可',
	// 特殊行业许可证
	subMerchantInfoTable: 'サブマーチャント情報テーブル',
	// 子商户信息表,
	bankAccountInformation: '同名の銀行口座証明書',
	// PH 新增
	registeredCapitalCertificate: '登録資本金証明書' // JP 新增
}
export default ja
